import React from "react";
import { useToast } from '@aptuno/aptuno-ui'

const Home = () => {
  const toast = useToast();
  return <h1>Bienvenido a Aptuno backoffice</h1>;
};

export default Home;
